module.exports = {"asl.heading":"ASL"}


//////////////////
// WEBPACK FOOTER
// ./src/components/i18n/locales/es.json
// module id = 704
// module chunks = 0